/* eslint-disable */
import {
  Box,
  Button,
  FormControlLabel,
  Typography,
  Checkbox as MuiCheckbox,
  Select,
} from '@mui/material'
import { useCallback, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import CardTAG from '../../components/CardTAG'
import Checkbox from '../../components/Checkbox'
import DividerTAG from '../../components/DividerTAG'
import Dropdown from '../../components/Dropdown'
import FormLayout from '../../components/forms/FormLayout'
import MainLayout from '../../components/MainLayout'
import colors from '../../constants/colors'
import selectOptions from '../../constants/selectOptions'
import { ReactComponent as DownIcon } from '../../assets/images/DownIcon.svg'
import LabelErrorTAG from '../../components/LabelErrorTAG'
import FilterComponent, { IFilterObject, IPreset } from '../../components/FilterComponent'
import useDebounce from '../../hooks/useDebounce'
import dayjs from 'dayjs'
import { selectStyle } from '../../constants/styleConstants'
import reportsService from '../../services/reportsService'
import constants from './constants'
import ModalTAG from '../../components/ModalTAG'
import jwtDecode from 'jwt-decode'
import { IAuthJWT } from '../../config/axios'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from '../../store'
import { getUserDetails } from '../../store/auth/authSlice'
import DateRangePicker from '../../components/DateRangePicker'
import useAutoLogout from '../../hooks/useAutoLogout'
import authSelectors from '../../store/auth/authSelectors'
import { APP_MODE } from '../../sharedTypes'
const currentTime = dayjs()

import { info } from '../../utils/alertUtils';


export const updateFilterObjectCheckedValue = (
  filterObjects: IFilterObject[],
  values: string[],
): IFilterObject[] | undefined => {
  const updatedFilterObjects: IFilterObject[] = filterObjects.map(filterObject => {
    if (values.includes(filterObject.value)) {
      return {
        ...filterObject,
        checked: !filterObject?.checked,
      }
    }
    if (filterObject.subTypes) {
      return {
        ...filterObject,
        subTypes: updateFilterObjectCheckedValue(filterObject.subTypes, values),
      }
    }
    return filterObject
  })

  return updatedFilterObjects
}

const testPresets: IPreset[] = [
  {
    id: 0,
    name: 'Preset 1',
    values: ['', ''],
    checked: false,
  },
]

const ExportPage: React.FC = () => {
  const [selectPages, setSelectPages] = useState<string>('all')
  const [selectedPages, setSelectedPages] = useState<number[]>([])
  const [enlargedPhoto, setEnlargedPhoto] = useState<{ url: string; id: number }>()
  const [filter, setFilter] = useState<IFilterObject[]>(constants.testFilter)
  const autoLogout = useAutoLogout()
  const debouncedFilterValue = useDebounce(filter, 500)
  const [dateRange, setDateRange] = useState<(Date | null)[] | undefined>([
    currentTime.subtract(7, 'day').toDate(),
    currentTime.toDate(),
  ])
  // @ts-ignore
  const [startDate, endDate] = dateRange
  const dispatch = useDispatch<AppDispatch>()
  const organizationType = useSelector(authSelectors.userOrganizationType)
  useEffect(() => {
    const tokenData: IAuthJWT = jwtDecode(localStorage.getItem('accessToken') || '')
    dispatch(getUserDetails({ userId: tokenData.user_id }))
  }, [])
  const formMethods = useForm<{
    exportType: string
    anonymize: false
    includeAttachments: false
    pagesRange: ''
  }>({
    defaultValues: { exportType: 'zip' },
    mode: 'onChange',
    shouldFocusError: false,
  })

  const { register, handleSubmit, formState, control, watch } = formMethods

  const exportTypeValue = watch('exportType') as string
  const anonymizeValue = watch('anonymize') as boolean
  const includeAttachmentsValue = watch('includeAttachments') as boolean

  const getMessage = useCallback(
    (field: 'exportType' | 'anonymize' | 'includeAttachments' | 'pagesRange') => {
      if (!formState.errors[field]) return ''

      return formState.errors[field]!.message
    },
    [formState],
  )

  const handleSelectPages = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectPages((event.target as HTMLInputElement).value)
  }

  const onChangePresetHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const values = event?.target?.value.split(',')
    const response = updateFilterObjectCheckedValue(constants.testFilter, values)
    if (response) {
      setFilter(response)
    }
  }

  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const response = updateFilterObjectCheckedValue(filter, [event?.target?.value])
    if (response) {
      setFilter(response)
    }
  }

  const renderPages = () => {
    if (!exportTypeValue) {
      return <></>
    }
    return constants?.pages[exportTypeValue]?.map(({ id, url }, index) => (
      <Box
        key={id}
        sx={{ height: '22.3rem', width: '22.5%', maxWidth: '22.5%', minWidth: '22.5%' }}
      >
        <Box sx={constants.imageHoverStyle}>
          <img src={url} style={{ objectFit: 'cover', width: '100%', height: '100%' }} />
          <Button className='enlargeButton' onClick={() => setEnlargedPhoto({ id, url })}>
            <Typography variant='bodyBold' color={colors.WHITE}>
              View Enlarged
            </Typography>
          </Button>
        </Box>
        <Box sx={{ paddingTop: '1rem' }}>
          <FormControlLabel
            control={<MuiCheckbox value={true} />}
            label={<Typography variant='boldTextMedium'>Page {index + 1}</Typography>}
          />
        </Box>
      </Box>
    ))
  }

  const getSelectedValuesForPresetFilters = (filters: IFilterObject[]) => {
    let selectedValues: { [key: string]: string } = {}

    filters.forEach(({ section, subTypes, value }) => {
      if (section && subTypes?.some(({ checked }) => checked)) {
        const checkedInSection = subTypes.filter(({ checked }) => checked).map(({ value }) => value)
        selectedValues = { ...selectedValues, [value]: checkedInSection.join() }
      }
    })

    return selectedValues
  }

  const doExport = async (requestData: { [key: string]: string | Date }) => {
    const { data, status } = await reportsService.getExportReports(requestData)
    if (status == 204) {
      info("No data found for this set of filters")
      return
    }
    window.location.assign(data.link)
  }

  const exportHandler = () => {
    const requestObject = {
      as: exportTypeValue,
      start_date: startDate,
      end_date: endDate,
      ...getSelectedValuesForPresetFilters(debouncedFilterValue),
      ...(exportTypeValue === 'xls'
        ? {
            violence_type:
              'Criminal Intent,Customer / Client,Worker on Worker,Personal Relationship',
          }
        : {}),
    }

    doExport(requestObject)
  }

  return (
    <MainLayout childrenSx={{ paddingRight: 0 }}>
      <Box sx={{ display: 'flex', width: '100%', height: '100%', justifyContent: 'flex-start' }}>
        <Box
          sx={{
            minWidth: { md: '96%', lg: '58%', xl: '50%' },
            maxWidth: { md: '96%', lg: '58%', xl: '50%' },
            height: '70vh',
          }}
        >
          <CardTAG title={'Export Case'}>
            <FormLayout>
              <Dropdown
                control={control}
                fieldName='exportType'
                label=''
                selectedValue={exportTypeValue}
                options={
                  organizationType === APP_MODE.light
                    ? selectOptions.exportPageOptions.filter(o => o.value !== 'xls')
                    : selectOptions.exportPageOptions
                }
                error={getMessage('exportType')}
              />
              <Box sx={{ width: '100%', display: 'flex', alignItems: 'start' }}>
                <Checkbox
                  control={control}
                  fieldName={'anonymize'}
                  value={anonymizeValue}
                  label={'Anonymize this Report?'}
                />

                <Checkbox
                  control={control}
                  fieldName={'includeAttachments'}
                  value={includeAttachmentsValue}
                  label={'Include Attachments?'}
                />
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '1rem', marginTop: '1.4rem' }}>
                <DateRangePicker
                  label={'Date Range'}
                  dateRange={dateRange}
                  setDateRange={setDateRange}
                  rangePicker
                />
              </Box>
              {exportTypeValue && (exportTypeValue === 'zip' || exportTypeValue === 'csv') && (
                <Box sx={{ width: { md: '47%', lg: '70%', xl: '57%' } }}>
                  <LabelErrorTAG label='Filter' />
                  <Select
                    sx={[selectStyle]}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          display: 'inline-block',
                          // minWidth: '40vw !important',
                          // maxWidth: 'initial',
                          overflow: 'visible',
                          backgroundColor: 'white',
                        },
                      },
                    }}
                  >
                    <FilterComponent
                      filterObject={filter}
                      onChangeHandler={onChangeHandler}
                      presets={testPresets}
                      onChangePresetHandler={onChangePresetHandler}
                    />
                  </Select>
                </Box>
              )}
              <DividerTAG />
              {/*               <Typography variant='h4'>Preview</Typography>
              <Box sx={{ width: '100%', display: 'flex', alignItems: 'start' }}>
                <RadioGroup
                  row
                  aria-labelledby='demo-row-radio-buttons-group-label'
                  name='row-radio-buttons-group'
                  value={selectPages}
                  onChange={handleSelectPages}
                  sx={{ width: 'inherit' }}
                >
                  <FormControlLabel value='all' control={<Radio />} label='Select All Pages' />
                  <FormControlLabel value='range' control={<Radio />} label='Select Range' />
                </RadioGroup>

                <TextInput
                  register={register}
                  fieldName={'pagesRange'}
                  label={''}
                  placeholder={'e.g. 1–4'}
                  disabled={selectPages !== 'range'}
                />
              </Box> 
              <Box sx={constants.pagesBox}>{renderPages()}</Box>
              */}
              <Button
                variant='outlined'
                startIcon={<DownIcon fill={colors.BLACK} />}
                sx={{ maxWidth: 'fit-content' }}
                onClick={exportHandler}
                disabled={!exportTypeValue}
              >
                <Typography variant='bodyRegular' color='inherit'>
                  Export
                </Typography>
              </Button>
            </FormLayout>
          </CardTAG>
        </Box>
      </Box>{' '}
      <ModalTAG open={!!enlargedPhoto} style={{ width: '40%', height: '80' }}>
        <CardTAG
          closable={true}
          closeCard={() => {
            setEnlargedPhoto(undefined)
          }}
          title={`Photo ${enlargedPhoto?.id}`}
        >
          <img
            src={enlargedPhoto?.url}
            style={{ objectFit: 'cover', width: '100%', height: '100%' }}
          />
        </CardTAG>
      </ModalTAG>
    </MainLayout>
  )
}

export default ExportPage
